
import { defineComponent, onMounted, onUnmounted, ref } from "vue";
import GenericPanel from "./GenericPanel.vue";
import "../../styles/loading-transitions.css";

export default defineComponent({
  name: "Header",
  components: { GenericPanel },
  setup() {
    const onlinePlayers = ref(null);
    const serverUptime = ref("");
    const errorMessage = ref("");
    let intervalId = null;
    let isFetching = false;

    const refetchData = () => {
      if (isFetching) return;

      const options = {
        headers: {
          "x-api-key": process.env.VUE_APP_X_API_KEY, // Send API key in the headers
        },
      };
      isFetching = true;
      // fetch("http://localhost:3000/server-status", options)
      fetch("https://geck-server.onrender.com/server-status", options)
        .then((response) => {
          if (!response.ok) {
            // Differentiate based on the response status
            if (response.status === 503) {
              return response.json().then((json) => {
                throw new Error(json.error || "Server Down");
              });
            } else {
              throw new Error("Service unavailable");
            }
          }
          return response.json();
        })
        .then((json) => {
          onlinePlayers.value = json.online;
          serverUptime.value = json.uptime;
          errorMessage.value = ""; // Clear any previous errors if the request succeeds
        })
        .catch((error) => {
          // Set the error message based on the type of error
          if (error.message === "Server Down") {
            errorMessage.value = "OFFLINE"; // Game server is down
          } else {
            errorMessage.value = "Service unavailable";
          }
        })
        .finally(() => {
          isFetching = false;
        });
    };

    onMounted(() => {
      // Set up the interval when the component is mounted
      refetchData();
      intervalId = setInterval(refetchData, 30000); // Refresh every 30 seconds
    });

    onUnmounted(() => {
      // Clear the interval when the component is unmounted to avoid memory leaks
      clearInterval(intervalId);
    });
    return {
      onlinePlayers,
      serverUptime,
      errorMessage,
    };
  },
});
